import React from 'react';

export const LoggedContext = React.createContext();

export const OnlineContext = React.createContext();
export const CircleContext = React.createContext();
export const NotifContext = React.createContext();
export const NotifNbreContext = React.createContext();
export const BreadcrumbContext = React.createContext();
